module.exports = __webpack_public_path__ + "static/media/2_game-officon.da9bb434.png";